import ScheduleInfo from './ScheduleInfo';

export default ScheduleInfo;
